import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { VoiceOperatorCallTypeSummarySearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportVoiceOperatorCallTypeSummary, sortVoiceOperatorCallTypeSummary } from '../../constants';
import { getVolumeAmountOperator, getListAllVolumeAmountOperator, onResetDefaultData } from '../../actions';
import { makeGetListVolumeAmountOperator, makeGetListAllVolumeAmountOperator } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import ModalOperatorMapListMultiSelect from '../../../../components/common/ModalOperatorMapListMultiSelect';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class VoiceOperatorCallTypeSummary extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listVoiceOperatorCallTypeSummary: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listVoiceOperatorCallTypeSummary: props.listVoiceOperatorCallTypeSummary,
      totalCount: getPageTotalCount({ ...state, items: props.listVoiceOperatorCallTypeSummary }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetVoiceOperatorCallTypeSummaryReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetVoiceOperatorCallTypeSummaryReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listVolumeAmountOperator');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListVoiceOperatorCallTypeSummary();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListVoiceOperatorCallTypeSummary());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListVoiceOperatorCallTypeSummary());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListVoiceOperatorCallTypeSummary();
    });
  };

  doGetListVoiceOperatorCallTypeSummary = () => {
    const { filter, page, size, sorted } = this.state;
    const { getVolumeAmountOperator } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortVoiceOperatorCallTypeSummary[sorted.sortCol]
          ? sortVoiceOperatorCallTypeSummary[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getVolumeAmountOperator(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistVoiceOperatorCallTypeSummary = cb => {
    const { filter, sorted } = this.state;
    const { getListAllVolumeAmountOperator } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortVoiceOperatorCallTypeSummary[sorted.sortCol][sorted.sortDir] : null,
    };
    getListAllVolumeAmountOperator(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistVoiceOperatorCallTypeSummary(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllVoiceOperatorCallTypeSummary, t } = this.props;
        convertJson2Pdf({
          data: listAllVoiceOperatorCallTypeSummary,
          t,
          title: t('reportPage:sidebar.voiceOperatorCallTypeSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.voiceOperatorCallTypeSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistVoiceOperatorCallTypeSummary(() => {
      const { listAllVoiceOperatorCallTypeSummary, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_ACTIVE_SUBSCRIPTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.voiceOperatorCallTypeSummary')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.voiceOperatorCallTypeSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllVoiceOperatorCallTypeSummary,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllVoiceOperatorCallTypeSummary,
          t,
          title: t('reportPage:sidebar.voiceOperatorCallTypeSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.voiceOperatorCallTypeSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.voiceOperatorCallTypeSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('VOICE_OPERATOR_CALL_TYPE_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportVoiceOperatorCallTypeSummary,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listVoiceOperatorCallTypeSummary,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllVoiceOperatorCallTypeSummary,
      t,
      permissions: { modeGetVoiceOperatorCallTypeSummaryReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetVoiceOperatorCallTypeSummaryReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.voiceOperatorCallTypeSummary') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.voiceOperatorCallTypeSummary')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <VoiceOperatorCallTypeSummarySearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  ModalSearch={props => {
                    return (
                      <div>
                        <ModalOperatorMapListMultiSelect
                          isOpen={props.isOpen === 'operatorId'}
                          onSelect={props.onSelect}
                          onCancel={props.onToggle}
                          // accountId={id}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.voiceOperatorCallTypeSummary').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllVoiceOperatorCallTypeSummary,
                          t,
                          title: t('reportPage:sidebar.voiceOperatorCallTypeSummary').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.voiceOperatorCallTypeSummary')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listVoiceOperatorCallTypeSummary}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listVoiceOperatorCallTypeSummary && listVoiceOperatorCallTypeSummary.length
                      ? listVoiceOperatorCallTypeSummary
                      : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

VoiceOperatorCallTypeSummary.propTypes = {
  getVolumeAmountOperator: PropTypes.func,
  getListAllVolumeAmountOperator: PropTypes.func,
  listAllVoiceOperatorCallTypeSummary: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

VoiceOperatorCallTypeSummary.defaultProps = {
  getVolumeAmountOperator: () => {},
  getListAllVolumeAmountOperator: () => {},
  listAllVoiceOperatorCallTypeSummary: [],
};

const mapStateToProps = createStructuredSelector({
  listVoiceOperatorCallTypeSummary: makeGetListVolumeAmountOperator() || [],
  listAllVoiceOperatorCallTypeSummary: makeGetListAllVolumeAmountOperator() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getVolumeAmountOperator,
    getListAllVolumeAmountOperator,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(VoiceOperatorCallTypeSummary)
);
